function Chat({ fill = "white" }) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4615 6.23074C12.4615 2.78959 9.67189 0 6.23074 0C2.78959 0 0 2.78959 0 6.23074C0 7.53307 0.399796 8.74187 1.083 9.74168L0.264619 12.1969L2.71985 11.3785C3.71962 12.0617 4.92842 12.4615 6.23074 12.4615C9.67189 12.4615 12.4615 9.67189 12.4615 6.23074Z"
        fill={fill}
      />
      <path
        d="M17.9998 11.7695C17.9998 8.97919 16.1654 6.6178 13.637 5.82422C13.6443 5.95928 13.6482 6.09489 13.6482 6.23106C13.6482 7.23189 13.4519 8.20341 13.0648 9.11864C12.6912 10.0021 12.1565 10.7952 11.4756 11.476C10.7948 12.1569 10.0017 12.6915 9.11825 13.0652C8.20302 13.4524 7.2315 13.6486 6.23067 13.6486C6.09446 13.6486 5.95885 13.6441 5.82367 13.6368C6.61705 16.1656 8.97856 18.0002 11.7691 18.0002C13.0714 18.0002 14.2802 17.6004 15.28 16.9172L17.7353 17.7356L16.9168 15.2804C17.6001 14.2807 17.9998 13.0718 17.9998 11.7695Z"
        fill={fill}
      />
    </svg>
  );
}

export default Chat;
